module.exports = __webpack_public_path__ + "static/media/search-minus.ae341ab2.svg";